import { useEffect, useState } from "react";
import { fetchPageBySlug } from "../api/axios";
import DynamicBreadcrumb from "../components/common/DynamicBreadcrumb";
import ContactForm from "../components/contact/ContactForm";
import { getContactPage } from "../api/axios";
import ContactUsContent from "../components/contact/ContactUsContent";
import TeamMembers from "../components/contact/TeamMembers";
import SupportContact from "../components/contact/SupportContact";
import ImageWithText from "../components/sections/ImageWithText";
import Seo from "../components/_App/seo";
import Preloader from "../components/_App/Preloader";

const Contact = () => {
  const [pageData, setPageData] = useState(undefined);
  const [heroData, setHeroData] = useState(undefined);
  const componentMap = {
    "sections.cta-section": ContactForm,
    "sections.image-with-text": ImageWithText,
    "sections.image-with-text": SupportContact,
    "sections.team-member": TeamMembers,
  };


  useEffect(() => {
    getContactPage().then((data) => {
      const heroSection = data.sections.find(
        (sec) => sec.__component === "hero-section.hero-section"
      );

      setHeroData(heroSection ?? null);
    });
  }, []);

  useEffect(() => {
    fetchPageBySlug("contact").then((data) => {
      setPageData(data ?? null);
    });
  }, []);

  if (pageData === undefined) return <Preloader />;
  if (heroData === undefined) return <Preloader />;
  if (!heroData) return null;

  return (
    <>
      {pageData && (
        <Seo
          seo={pageData?.seo}
          slug={pageData?.slug}
        />
      )}
      <DynamicBreadcrumb />

      <ContactUsContent data={heroData} />

      {pageData?.sections?.map((section, id) => {
        const SectionComponent = componentMap[section.__component];

        return SectionComponent ? (
          <SectionComponent key={section.id} data={section} />
        ) : null;
      })}
    </>
  )
}

export default Contact
